<template>
  <div class="" v-loading="orderLoading">
    <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button  plain  @click="back"
          >取消</el-button
        >
        <el-button type='primary' 
               @click="submitOrder()">提交订单</el-button>
      </div>
    </ZnBreadcrumb>
  <div class="main-content"
       v-title
       data-title="订单确认_试剂采购库存管理系统">

    <div class="goods-location table-style">
      <div class="table-title">
        <span>收货地址</span>
        <div class="handel-btn">
          <el-button type="primary"
                     @click="dialogAddress=true">新增地址</el-button>
        </div>
      </div>
      <div class="default-address">
        <img src="../../assets/images/address.png"
             alt="">
        <div class="details">
          <p class="name">{{defaultAddress.fullName}} <i>{{defaultAddress.phone}}</i><span v-if="defaultAddress.def">默认</span></p>
          <p class="address">收货地址：{{defaultAddress.province}}{{defaultAddress.area}}{{defaultAddress.city}}{{defaultAddress.address}}</p>
        </div> 
        <i class="el-icon-arrow-down icon"
           v-if="!isShowAllAddress"
           @click="isShowAllAddress=true" >选择地址</i>
          



           
        <i class="el-icon-arrow-up icon icon-up"
           v-if="isShowAllAddress"
           @click="isShowAllAddress=false"></i>
        <div class="all-address details"
             v-if="isShowAllAddress">
          <ul>

            <li v-for="(item) in allAddress"
                :key="item.id"
                @click="changeAddres(item.id)">
              <p class="name">{{item.fullName}} <i>{{item.phone}}</i><span v-if="item.def">默认</span></p>
              <p class="address">收货地址：{{item.province}}{{item.area}}{{item.city}}{{item.address}}</p>
            </li>

          </ul>
        </div>
      </div>

    </div>
    <div class="goods-info table-style" v-show="this.shopList.length > 0">
      <div class="table-title">
        <span>试剂商品信息</span>
      </div>
<!--      <div v-for="(item,index) in shopList" :key="index" class="pre-info">-->
      <div class="pre-info">
<!--        <div class="supplierTitle">-->
<!--          <el-divider direction="vertical"></el-divider>-->
<!--          <span >供应商：</span><span style="color: #ff9a02">{{item.supplierName}}</span>-->
<!--        </div>-->
        <el-table :data="shopList"
                  :header-cell-style="{background:'#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight:600,height:'54px'}"
                  border :span-method="orderSpanMethod"
                  style="width: 100%">
          <el-table-column prop="supplierName"
                           label="供应商">
          </el-table-column>
          <el-table-column prop="goodsNo"
                           label="商品编码">
          </el-table-column>
          <el-table-column prop="goodsName"
                           label="商品名称">
          </el-table-column>
          <el-table-column prop="casNo"
                           label="CAS号">
          </el-table-column>
          <el-table-column label="品牌" prop="brand">
          </el-table-column>
          <el-table-column prop="weightUnit" label="剂量（单位）">
            <template v-slot="scope">
              <span v-if="scope.row.weightUnit">{{scope.row.weightUnit}}</span>
              <span v-else>{{scope.row.weight}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num"
                           label="购买量">
          </el-table-column>

          <el-table-column prop="salesPrice"
                           label="单价">
            <template v-slot="scope">
              <span>{{scope.row.salesPrice}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="freightPre"
                           label="预估运费(以实际结算为准)">
            <template v-slot="scope">
              <span>{{scope.row.freightPre}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="freightDetailDesc" label="运费规则" width="108">
            <template slot-scope="scope">
              <span v-show="scope.row.freightPre > 0"><el-link type="primary" @click="getFreightDesc(scope.row)">查看运费规则</el-link></span>
            </template>
          </el-table-column>
          <el-table-column prop="amt"
                           label="小计">
            <template v-slot="scope">
<!--              <span>{{(scope.row.salesPrice*scope.row.num*100/100)+scope.row.freightPre}}元</span>-->
              <span>{{scope.row.amt}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="gjwz"
                           label="绑定柜机">
          </el-table-column>

        </el-table>
      </div>

    </div>
    <div class="goods-info table-style" v-show="this.materialList.length > 0">
      <div class="table-title">
        <span>耗材商品信息</span>
      </div>
      <div class="pre-info">
        <el-table :data="materialList"
                  :header-cell-style="{background:'#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight:600,height:'54px'}"
                  border :span-method="materialSpanMethod"
                  style="width: 100%">
          <el-table-column prop="supplierName"
                           label="供应商">
          </el-table-column>
          <el-table-column prop="goodsNo"
                           label="商品编码">
          </el-table-column>
          <el-table-column prop="goodsName"
                           label="商品名称">
          </el-table-column>
          <el-table-column label="品牌" prop="brand">
          </el-table-column>
          <el-table-column label="规格" prop="specNames" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="weightUnit" label="剂量（单位）">
            <template v-slot="scope">
              <span v-if="scope.row.productType == 1">{{ scope.row.packageType }}</span>
              <span v-else>EA</span>
            </template>
          </el-table-column>
          <el-table-column prop="num"
                           label="购买量">
          </el-table-column>

          <el-table-column prop="salesPrice"
                           label="单价">
            <template v-slot="scope">
              <span>{{scope.row.salesPrice}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="freightPre"
                           label="预估运费(以实际结算为准)">
            <template v-slot="scope">
              <span>{{scope.row.freightPre}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="freightDetailDesc" label="运费规则" width="108">
            <template slot-scope="scope">
              <span v-show="scope.row.freightPre > 0"><el-link type="primary" @click="getFreightDesc(scope.row)">查看运费规则</el-link></span>
            </template>
          </el-table-column>
          <el-table-column prop="amt"
                           label="小计">
            <template v-slot="scope">
<!--              <span>{{(scope.row.salesPrice*scope.row.num*100/100)+scope.row.freightPre}}元</span>-->
              <span>{{scope.row.amt}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="gjwz"
                           label="绑定柜机">
          </el-table-column>

        </el-table>
      </div>

    </div>
    <div class="census clearfix">
      <span class="amount">订单总额：<i>¥ {{totalPrice}} 元</i></span>
      <span class="total">商品金额：<i>{{totalAmt}} 元</i></span>
      <span class="total">运费：<i>{{totalFreight}} 元</i></span>
      <span class="total">数量：<i>{{allNum}} 件</i></span>
    </div>
    <!-- 新增地址弹框 -->
    <el-dialog title="新增地址"
               :visible.sync="dialogAddress"
               class="addressDia"
               width="460px">
      <ul class="diaWhole">
        <li>
          <label>联系人姓名</label>
          <input type="text"
                 v-model="address.fullName"
                 placeholder="请输入联系人姓名">
        </li>
        <li>
          <label>联系人电话</label>
          <input type="text"
                 maxlength="11"
                 v-model="address.phone"
                 placeholder="请输入联系人电话">
        </li>
        <li>
          <label>地址信息</label>
          <!-- <input type="text"
                 v-model="address.phone"
                 placeholder="请选择省/市/区/街道"> -->
          <!-- <el-tabs v-model="addressVal"
                   type="card"
                   @tab-click="handleClick">
            <el-tab-pane label="省"
                         name="first">
              <ul class="address">
                <li v-for="(item,index) in addressList"
                    :key="index">{{item.fullName}}</li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="市"
                         name="second">市</el-tab-pane>
            <el-tab-pane label="区"
                         name="third">区</el-tab-pane>
          </el-tabs> -->
          <el-cascader placeholder="请选择省/市/区/街道"
                       ref="refValue"
                       :options="addressList"
                       :props="optionProps"
                       v-model="addressName"
                       @change="chooseArea"></el-cascader>
        </li>
        <li>
          <label>详细地址</label>
          <input type="text"
                 v-model="address.address"
                 placeholder="请输入详细地址">
        </li>
        <li>
          <label>设为默认地址</label>
          <el-switch v-model="address.def">
          </el-switch>
        </li>
      </ul>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogAddress = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmBorrow()">确 定</el-button>
      </div>
    </el-dialog>
    <div >
      <el-dialog title="运费规则介绍" :visible.sync="freightDetailDialog" width="30%" >
        <div class="div-item" style="margin-top: 10px;font-size: 16px;font-weight: 500;line-height: 30px;">
          <ul style="list-style: initial;margin-left: 20px;margin-top: 20px">
            <li><span>{{this.freightDetailDesc}}</span></li>
          </ul>
        </div>
        <div style="min-height: 50px;">
        </div>
      </el-dialog>
    </div>
    <div >
      <el-dialog title="运费规则介绍" :visible.sync="freightGreagentDetailDialog" width="30%" >
        <div class="div-item" style="margin-top: 10px;font-size: 16px;font-weight: 500;line-height: 30px;">
          <ul style="list-style: none;margin-left: 20px;margin-top: 20px">
            <li><span>1、运费基数：每商品对应1个运费基数</span></li>
            <li><span>2、运费单位=向上取整（∑（运费基数×购买商品数）/20）</span></li>
            <li><span>3、如果运费单位＝0，订单运费＝0</span></li>
            <li><span>4、如果运费单位≠0</span></li>
            <li><span style="font-weight: 700;">上海地区：</span></li>
            <li><span style="margin-left: 30px;">商品总金额＜200，订单运费=20元</span></li>
            <li><span style="margin-left: 30px;">商品总金额≥200，订单运费=0</span></li>
            <li><span style="font-weight: 700;">自送地区：</span></li>
            <li><span style="margin-left: 30px;">杭州、苏州、无锡、常州、南京、合肥、沈阳、大连、北京、天津、石家庄、济南、青岛、烟台、武汉、成都、重庆、昆明、贵阳、广州、深圳、福州、厦门、南昌、长沙、西安、呼和浩特、兰州、郑州、长春</span></li>
            <li><span style="margin-left: 30px;">商品总金额＜300，订单运费=30元；</span></li>
            <li><span style="margin-left: 30px;">商品总金额≥300，订单运费=0</span></li>
            <li><span style="font-weight: 700;">其他地区：</span></li>
            <li><span style="margin-left: 30px;">0＜运费单位≤1</span></li>
            <li><span style="margin-left: 30px;">0＜运费基数≤1，区域运费1*1</span></li>
            <li><span style="margin-left: 30px;">1＜运费基数≤5，区域运费1*2</span></li>
            <li><span style="margin-left: 30px;">5＜运费基数≤10，区域运费1*4</span></li>
            <li><span style="margin-left: 30px;">10＜运费基数≤15，区域运费1*5</span></li>
            <li><span style="margin-left: 30px;">15＜运费基数≤20，区域运费1*7</span></li>
            <li><span style="margin-left: 30px;">1＜运费单位≤80，订单运费=区域运费2*运费单位+120元</span></li>
            <li><span style="margin-left: 30px;">80＜运费单位，订单运费=区域运费2*运费单位</span></li>

            <li><span style="margin-left: 30px;">商品总金额＜3000，订单运费=计算值；</span></li>
            <li><span style="margin-left: 30px;">商品总金额≥3000且运费计算值≤150，订单运费=0</span></li>
            <li><span style="margin-left: 30px;">商品总金额≥3000且运费计算值≤150，订单运费=0</span></li>
          </ul>
        </div>
        <div style="min-height: 50px;">
        </div>
      </el-dialog>
    </div>
  </div>
  </div>
</template>
<script>
import addressData from '../../components/area.json'
 import { EventBus } from "../../config/event-bus.js";
export default {
  data() {
    return {
      freightDetailDesc: "",
      freightGreagentDetailDialog: false,
      freightDetailDialog: false,
      orderLoading:false,
      defaultAddress: {
         address: '',
        area: '',
        areaId: '',
        city: '',
        cityId: '',
        def: false,
        fullName: '',
        phone: '',
        province: '',
        provinceId: '',
      },
      allAddress: [], //用户所有地址
      // nowAddress: {}, //切换地址
      addressName: '',
      addressList: [], //全国所有位置
      address: {
        address: '',
        area: '',
        areaId: '',
        city: '',
        cityId: '',
        def: false,
        fullName: '',
        phone: '',
        province: '',
        provinceId: '',
      },
      optionProps: {
        value: 'id',
        label: 'fullName',
        children: 'children',
      },
      addressId: '',
      shopList: [],
      materialList: [],
      allNum: '',
      isStock: null,//如果为1，代表是期货商品结算，需走另一套逻辑
      totalPrice: '',
      totalFreight: '',
      totalAmt: '',
      dialogAddress: false,
      isShowAllAddress: false,
      mergeColIndex: [], // 要合并的列的序号，从0 开始
      mergeObj: {},
      mergeArr: ['supplierName', 'brand','freightPre','amt','freightDetailDesc'],


      mergeColIndex1: [], // 要合并的列的序号，从0 开始
      mergeObj1: {},
    }
  },
  created() {
    this.getMyAddress()
    this.getDefaultAddress()
    this.addressList = addressData
  },
  methods: {
    //我的订单菜单 角标数量显示
    getConfirmOrder() {
      this.$apiFetch
          .get("/lockerOrders/getConfirmOrder")
          .then((res) => {
            localStorage.setItem("confirmOrder",res.data);
            EventBus.$emit('confirmOrder',res.data);
          });
    },
    //获取我的收货地址
    getMyAddress() {
      this.$apiFetch.get('/user-address').then((res) => {
        this.allAddress = res.data

        this.dialogAddress = false
      })
    },
    //获取默认地址
    getDefaultAddress() {
      this.$apiFetch.get('/user-address/default').then((res) => {
        if( res.data!=""){
        this.defaultAddress = res.data
        this.addressId = res.data.id
        }
        this.getGoodsList();
      })
    },
    //切换地址
    changeAddres(id) {
      this.allAddress.map((item) => {
        if (item.id == id) {
          this.defaultAddress = item
          this.addressId = item.id
        }
      })
      this.isShowAllAddress = false


      //切换地址后，需要重新计算运费
      this.getGoodsList();
    },
    //新增地址
    confirmBorrow() {
      let params = this.address
      const {area,areaId,city,cityId,fullName,phone,province,provinceId,address} = params
      if(!area || !areaId || !city || !cityId || !fullName || !phone || !province || !provinceId || !address){
          this.$message({
            showClose: true,
            message: '请填写完整后提交',
            type: "error",
          });
          console.log(params)
          return
      }
      let reg=/^((0\d{2,3}-\d{7,8})||(1[3456789]\d{9}))$/;
      let reg2=/^0\d{2,3}-?\d{7,8}$/;

      if(!reg.test(phone)){
        if(!reg2.test(phone)){
          this.$message.error('请输入正确的电话号码~')
          return;
        }
        this.$message.error('请输入正确的电话号码!')
        return;
      }

                //成功后带出地址
          debugger;
          console.log(this.address.fullName)

          this.defaultAddress.fullName=this.address.fullName;
          this.defaultAddress.phone=this.address.phone;
          this.defaultAddress.province=this.address.province;
          this.defaultAddress.area=this.address.area;
          this.defaultAddress.city=this.address.city;
          this.defaultAddress.address=this.address.address;

      this.$apiFetch.post('/user-address', params).then((res) => {
        console.log(res)
        if(!res.data.code){
          
          //this.defaultAddress.addressId=res.data.id;
          this.addressId=res.data.id;
          this.getMyAddress()
          this.getGoodsList();
          //this.getDefaultAddress()
          this.addressName = ''
          for (let key in this.address) {
            this.address[key] = ''
          }
          debugger;
          this.address.def = false




 


        }else{
          this.$message.error(res.data.description)
        }
      })
    },
    //选择地址
    chooseArea(value) {
      console.log(this.addressName)
      let chineseValue = this.$refs['refValue'].getCheckedNodes()[0].pathLabels
      this.address.province = chineseValue[0]
      this.address.city = chineseValue[1]
      this.address.area = chineseValue[2]
      this.address.provinceId = value[0]
      this.address.cityId = value[1]
      this.address.areaId = value[2]
    },
    //商品列表
    getGoodsList() {
      this.shopList = [];
      this.materialList = [];
      let addressId = this.addressId
      this.$apiFetch.get('/lockerOrders/getCalculateOrder1?addressId='+addressId).then((res) => {
        if(res.data.code == 418){
          return;
        }
        this.shopList = res.data.shopList;
        this.materialList = res.data.materialList;
        this.allNum = res.data.allNum
        this.totalPrice = res.data.totalPrice
        this.isStock = res.data.isStock
        this.totalFreight = res.data.totalFreight
        this.totalAmt = res.data.totalAmt
        this.getSpanArr(this.shopList);
        this.getSpanArr1(this.materialList);
      })
    },
    //正常商品结算
    settlement1(addressId) {
      this.$apiFetch
          .get(`/lockerOrders/tallyOrder?addressId=${addressId}`)
          .then((res) => {
            this.orderLoading = false
            console.log(res)
            if (res.data.code == 418) {
              this.$message.error(res.data.description)
            } else {
              this.$message.success('提交成功')
              this.$router.push('/myOrder');

              this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
                EventBus.$emit('showCityName', res.data);
                localStorage.setItem("test", res.data)
              });
              this.$apiFetch
                  .get("/lockerOrders/getUnCheckedOrder")
                  .then((res) => {
                    localStorage.setItem("UnCheckedOrder", res.data);
                    EventBus.$emit("UnCheckedOrder", res.data);
                  });
              //修改我的订单角标数量显示
              this.getConfirmOrder();
            }
          }).catch((err) => {
        this.orderLoading = false
      })
    },
    //期货商品结算
    settlement2(addressId) {
      this.$apiFetch
          .get(`/lockerOrders/tallyStockOrder?addressId=${addressId}`)
          .then((res) => {
            this.orderLoading = false
            console.log(res)
            if (res.data.code == 418) {
              this.$message.error(res.data.description)
            } else {
              this.$message.success('采购期货商品成功，稍后会有客服跟您联系！')
              this.$router.push('/myPurchase');

              this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
                EventBus.$emit('showCityName', res.data);
                localStorage.setItem("test", res.data)
              });
              this.$apiFetch
                  .get("/lockerOrders/getUnCheckedOrder")
                  .then((res) => {
                    localStorage.setItem("UnCheckedOrder", res.data);
                    EventBus.$emit("UnCheckedOrder", res.data);
                  });
              //修改我的订单角标数量显示
              this.getConfirmOrder();
            }
          }).catch((err) => {
        this.orderLoading = false
      })
    },
    //提交订单
    submitOrder() {
      this.orderLoading = true;
      let addressId = this.addressId
      if(!addressId){
        this.$message.error('请选择收货地址后提交')
        this.orderLoading = false;
        return
      }
      if(1 == this.isStock){
        this.settlement2(addressId);
      }else {
        this.settlement1(addressId);
      }
    },
    //取消
    back() {
      this.$router.push("/myPurchase");
    },
    getSpanArr(data) {
      this.mergeArr.forEach((key, index1) => {
        let count = 0; // 用来记录需要合并行的起始位置
        this.mergeObj[key] = []; // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if(index === 0) {
            this.mergeObj[key].push(1);
          } else {
            if(key == 'supplierName' || key == 'brand' || key == 'amt'){
              // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
              if(item[key] === data[index - 1][key]) {
                this.mergeObj[key][count] += 1;
                this.mergeObj[key].push(0);
              } else {
                // 如果当前行和上一行其值不相等
                count = index; // 记录当前位置
                this.mergeObj[key].push(1); // 重新push 一个 1
              }
            }else if(key == 'freightPre' || key == 'freightDetailDesc'){
              // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
              if(item[key] === data[index - 1][key] && item['brand'] === data[index - 1]['brand'] ) {
                this.mergeObj[key][count] += 1;
                this.mergeObj[key].push(0);
              } else {
                // 如果当前行和上一行其值不相等
                count = index; // 记录当前位置
                this.mergeObj[key].push(1); // 重新push 一个 1
              }
            }
          }
        })
      })
    },

    getSpanArr1(data) {
      this.mergeArr.forEach((key, index1) => {
        let count = 0; // 用来记录需要合并行的起始位置
        this.mergeObj1[key] = []; // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if(index === 0) {
            this.mergeObj1[key].push(1);
          } else {
            if(key == 'supplierName' || key == 'brand' || key == 'amt'){
              // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
              if(item[key] === data[index - 1][key]) {
                this.mergeObj1[key][count] += 1;
                this.mergeObj1[key].push(0);
              } else {
                // 如果当前行和上一行其值不相等
                count = index; // 记录当前位置
                this.mergeObj1[key].push(1); // 重新push 一个 1
              }
            }
            else if(key == 'freightPre' || key == 'freightDetailDesc'){
              // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
              //if(item[key] === data[index - 1][key] && item['brand'] === data[index - 1]['brand'] ) {
              if(item[key] === data[index - 1][key]) {
                this.mergeObj1[key][count] += 1;
                this.mergeObj1[key].push(0);
              } else {
                // 如果当前行和上一行其值不相等
                count = index; // 记录当前位置
                this.mergeObj1[key].push(1); // 重新push 一个 1
              }
            }
          }
        })
      })
    },


    orderSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断列的属性
      if(this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if(this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0];
        }
      }
    },



    materialSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断列的属性
      if(this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if(this.mergeObj1[column.property][rowIndex]) {
          return [this.mergeObj1[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0];
        }
      }
    },
    getFreightDesc(row){
      console.log(row);
      const brandId = row.brandId;
      const brand = row.brand;
      const supplierName = row.supplierName;
      if(supplierName == '探索'){
        this.freightGreagentDetailDialog = true;
      }else {
        this.$apiFetch.get(`/lockerShopCart/getFreightDesc`, {brandId: brandId}).then((res) => {
          this.freightDetailDialog = true;
          this.freightDetailDesc = res.data;
        }).catch(err => {

        })
      }


    }
  },
}
</script>
<style lang="less" scoped>
.supplierTitle {
  color: #333333;
  font-size: 15px;
  line-height: 50px;
  font-weight: 700;
  padding-left: 10px;
}
.table-style {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 4px;
  .table-title {
    position: relative;
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    position: relative;
    padding-left: 11px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f8;
    .handel-btn {
      position: absolute;
      right: 0;
      bottom: 9px;
      button {
        width: 98px;
        height: 36px;
        border-radius: 4px;
        font-size: 12px;
      }
    }
  }
  .table-title::before {
    width: 3px;
    height: 16px;
    background: #478aff;
    content: '';
    position: absolute;
    left: -6px;
    top: 3px;
  }
}
.goods-location {
  .default-address {
    position: relative;
    background: #f8fafc;
    border-radius: 4px;
    width: 820px;
    height: 110px;
    margin-top: 20px;
    padding: 24px;
    box-sizing: border-box;

    img {
      display: block;
      width: 49px;
      float: left;
      margin-right: 12px;
    }
    .details {
      overflow: hidden;
      p.name {
        display: flex;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        font-weight: 700;
        i {
          padding-left: 25px;
        }
        span {
          display: block;
          width: 36px;
          height: 20px;
          background: #fa8c16;
          border-radius: 4px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          margin-left: 18px;
          font-weight: normal;
        }
      }
      p.address {
        color: #333333;
        line-height: 20px;
        font-size: 14px;
        padding-top: 12px;
      }
    }
    i.icon {
      position: absolute;
      top: 47px;
      right: 24px;
      color: #999999;
    }
    i.icon-up {
      color: #5593ff;
    }
  }
  .all-address {
    z-index: 999;
    position: absolute;
    top: 123px;
    left: 0;
    border-radius: 4px;
    width: 821px;
    background: #ffffff;
    box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
    border-radius: 4px;
    ul {
      li:hover {
        background-color: #f8fafc;
      }
      li {
        padding: 24px 0;
        border-bottom: 1px solid #e8e8e8;
        padding-left: 85px;
      }
    }
  }
}
.goods-info {
  margin-top: 20px;
  img {
    display: block;
    width: 70px;
  }
  .pre-info {
    margin-bottom: 16px;
  }
  .specNames {
    height: 53px;
    line-height: 53px;
    padding-left: 16px;
    border: 1px solid #e8e8e8;
    border-top: none;
    p {
      color: rgba(0, 0, 0, 0.65);

      font-size: 12px;
    }
  }
  .bind-goods {
    width: 50%;
    text-align: left;
  }
  .del-goods {
    color: #ff4d4f;
  }
}
.addressDia {
  ul.diaWhole {
    li {
      padding-top: 20px;
      line-height: 40px;
      box-sizing: border-box;
      position: relative;
      /deep/ .el-switch.is-checked .el-switch__core {
        background-color: #478aff;
        color: #478aff;
      }

      // /deep/ .el-tabs {
      //   width: 308px;
      //   position: absolute;
      //   right: 0;
      //   z-index: 999;
      //   top: 8px;
      //   border-radius: 4px;
      //   box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
      //   background: #fafafa;
      //   height: 260px;
      //   overflow-y: auto;
      //   .el-tabs__content {
      //     background-color: #ffffff;
      //   }
      //   .el-tabs__header {
      //     border: none;
      //     margin: 0;
      //   }
      //   .el-tabs__nav {
      //     width: 100%;
      //     border: none;
      //     .el-tabs__item {
      //       width: 33.33%;
      //       color: #999999;
      //       border: none;
      //     }

      //     .el-tabs__item.is-active {
      //       background-color: #ffffff;
      //       color: #333333;
      //       font-weight: 700;
      //     }
      //   }
      //   ul.address {
      //     padding-top: 5px;
      //     li {
      //       line-height: 54px;
      //       color: #333333;
      //       padding-left: 16px;
      //       padding-top: 0;
      //     }
      //     li:hover {
      //       background-color: #f8fafc;
      //     }
      //   }
      // }
      /deep/ .el-cascader {
        width: 77%;
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #cccccc;
          border-radius: 0;
          padding: 0;
        }
      }
      label {
        display: block;
        color: #666666;
        font-size: 14px;
        float: left;
        width: 23%;
        line-height: 40px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 77%;
        color: #333333;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      input::-webkit-input-placeholder {
        color: #cccccc;
      }

      .tips {
        font-size: 12px;
        line-height: 18px;
        color: #999999;
        padding-top: 6px;
        display: block;
      }
    }
    li:first-child {
      padding-top: 0;
    }
    li:last-child {
      input {
        border-bottom: 1px dashed #cccccc;
      }
    }
  }
}
.census {
  padding: 0 20px 20px 0;
  background-color: #ffffff;
  span {
    color: #333333;
    font-size: 13px;
    float: right;

    i {
      font-weight: 600;
      font-size: 15px;
    }
  }
  span.total {
    padding-right: 32px;
  }
}
</style>

